import selectionUtils from 'utils/selectionUtils';

function startContainerToUpperCase(range) {
    var node = range.startContainer;
    var currentRange = range.clone();
    if (node.type === CKEDITOR.NODE_TEXT && node.getText()) {
        var startText = node.$.textContent.substring(0, range.startOffset);
        var endText = node.$.textContent.substring(range.startOffset).toLocaleUpperCase();
        node.$.textContent = startText + endText;
    }
    currentRange.select();
}

function endContainerToUpperCase(range) {
    var node = range.endContainer;
    var currentRange = range.clone();
    if (node.type === CKEDITOR.NODE_TEXT && node.getText()) {
        var startText = node.$.textContent.substring(0, range.endOffset).toLocaleUpperCase();
        var endText = node.$.textContent.substring(range.endOffset);
        node.$.textContent = startText + endText;
    }
    currentRange.select();
}

function singleTextNodeToUpperCase(range) {
    var node = range.endContainer;
    var currentRange = range.clone();
    if (node.type === CKEDITOR.NODE_TEXT && node.getText()) {
        var startText = node.$.textContent.substring(0, range.startOffset);
        var middleText = node.$.textContent.substring(range.startOffset, range.endOffset).toLocaleUpperCase();
        var endText = node.$.textContent.substring(range.endOffset);
        node.$.textContent = startText + middleText + endText;
    }
    currentRange.select();
}

export default {
    exec: function (editor) {
        var selectedRange = selectionUtils.getSelectedRange(editor);
        var walker = new CKEDITOR.dom.walker(selectedRange),
            node;

        if (selectedRange.startContainer.equals(selectedRange.endContainer) && selectedRange.endContainer.type === CKEDITOR.NODE_TEXT) {
            singleTextNodeToUpperCase(selectedRange);
            return;
        }
        var currentRange = selectedRange.clone();
        startContainerToUpperCase(selectedRange);
        endContainerToUpperCase(selectedRange);
        while ((node = walker.next())) {
            if (node.type === CKEDITOR.NODE_TEXT && node.getText() && !node.equals(selectedRange.startContainer) && !node.equals(selectedRange.endContainer)) {
                node.$.textContent = node.$.textContent.toLocaleUpperCase();
            }
        }
        currentRange.select();
    }
};
